import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { StudioMasterComboBoxComponent } from './studio-master-combo-box.component';

/**
 * 撮影場所コンボボックスモデル
 *
 * @export StudioMasterComboBoxModel
 * @class StudioMasterComboBoxModel
 */
export class StudioMasterComboBoxModel {

  // 撮影場所リスト
  public studioMasterList: Array<any>;
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // 撮影場所リスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 撮影場所ID設定用
  public setStudioId: string;
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;

  public component: StudioMasterComboBoxComponent;                   // コンボボックスインスタンス


  /**
   * 撮影場所を更新する
   *
   * @param {*} serverData 撮影場所のサーバ取得データ
   * @memberof StudioMasterComboBoxModel
   */
  public updateStudioMasterList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankStudioObject());
      index = 1;
    }

    // 撮影場所ID+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].StudioIdName =
       tempDataList[index].StudioId + ':' + tempDataList[index].StudioName;
    }

    this.studioMasterList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedStudioId();
  }

  /**
   * 空白の撮影場所オブジェクトを取得する
   *
   * @private
   * @returns {object} 撮影場所オブジェクト
   * @memberof StudioMasterComboBoxModel
   */
  private getBlankStudioObject(): object {
    const ob: any = {};
    ob.StudioId = '';
    ob.StudioName = '';
    ob.StudioAddress = '';
    ob.Path = '';
    ob.StudioIdName = '';
    return ob;
  }

}
